import ReportActions from '../reducer/reportRedux';

const postReport = (params, meta = {}) => {
  return ReportActions.postReportRequest(params, meta);
};

export { postReport };
